import { useContext, useEffect, useState } from "react";
import Tabbar from "../../../components/shared/tabbar/tabbar";
import { TabbarOption } from "../../../components/shared/tabbar/types/tabbarProps";
import AdministrationNotificationView from "./AdministrationNotificationView/administrationNotificationView";
import AdministrationPermissionView from "./AdministrationPermissionView/administrationPermissionView";
import { AdministrationViewProps, AdministrationViewTypes } from "./types/AdministrationViewProps";
import './administrationView.scss';
import AdministrationPermissionExtendedView from "./AdministrationPermissionExtendedView/administrationPermissionExtendedView";
import { ReactComponent as Notifications } from "../../../icons/notifications.svg";
import { ReactComponent as BusinessCenter } from "../../../icons/business_center.svg";
import { ReactComponent as Tune } from "../../../icons/tune.svg";
import PermissionsContext from "../../../contexts/permissionsContext";

const AdministrationView = (props: AdministrationViewProps) => {
    const { functionsPermissions } = useContext(PermissionsContext);
    const [viewType, setViewType] = useState<AdministrationViewTypes>(AdministrationViewTypes.Notifications);

    useEffect(() => {
        if (!functionsPermissions.configureNotifications.active) setViewType(AdministrationViewTypes.Permissions);

    // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [])

    const onClickOption = (navigate: number) => {
        return (event: React.SyntheticEvent<HTMLLIElement>) => {
            event.currentTarget.className = "activeTab";
            setViewType(navigate);
        }
    }

    const renderView = (viewType: number) => {
        switch (viewType) {
            case AdministrationViewTypes.Notifications:
                return (<AdministrationNotificationView />)
            case AdministrationViewTypes.Permissions:
                return (<AdministrationPermissionView />)
            case AdministrationViewTypes.PermissionsExtended:
                return (<AdministrationPermissionExtendedView />)  
        }
    }

    const iconStyleTabbar: React.CSSProperties = {
        fill: "#453F3A", 
        width: "24px", 
        height: "24px"
    }

    var Options: TabbarOption[] = [
        ...functionsPermissions.configureNotifications.active ? [{ name: 'Powiadomienia', additionalIcon: Notifications, additionalIconStyle: iconStyleTabbar, onClick: onClickOption(AdministrationViewTypes.Notifications) }] : [],
        ...functionsPermissions.configurePermissions.active ? [{ name: 'Uprawnienia', additionalIcon: BusinessCenter, additionalIconStyle: iconStyleTabbar,  onClick: onClickOption(AdministrationViewTypes.Permissions) }] : [],
        ...functionsPermissions.configurePermissions.active ? [{ name: 'Uprawnienia dodatkowe', additionalIcon: Tune, additionalIconStyle: iconStyleTabbar,  onClick: onClickOption(AdministrationViewTypes.PermissionsExtended) }] : []
    ]

    return (<div className="administrationView"><Tabbar selected={!functionsPermissions.configureNotifications.active ? viewType - 1 : viewType} options={Options} tabWidth={"170px"}></Tabbar>{renderView(viewType)}</div>);
}

export default AdministrationView;
